import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateDefensivePayload } from "../../../products/types";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";
import { createFormData } from "../helpers/createFormdata";

export const useUpdateDefensive = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: CreateDefensivePayload }) => {
            try {
                const formdata = createFormData(data);
                return (await api.put(`/agricultural-defensives/update/${id}`, formdata)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar defensivo');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['defensives'] });
            queryClient.invalidateQueries({ queryKey: ['defensive', variables.id] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar defensivo:', getApiErrorMessage(error, 'Erro ao atualizar defensivo'))
        },
    });
};
